// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"323":"822989d6","447":"822989d6","554":"822989d6","847":"822989d6","943":"822989d6"}[chunkId] + ".chunk.css";
};